import { LineSheetSet } from "@/features/line-sheet-sets/line-sheet-set.types";

export type CanOrderByUnitSource = Pick<
  LineSheetSet,
  "type" | "sendToPathpick" | "pathpickDeadline"
>;

// 소량(단품) 주문이 되는 세트인지 — 패스픽에 올라간 스탁오더 세트, 마감 전까지.
// 바이어 목록의 '소량 주문 가능' 배지와 서버(pathpick_open__eq, LineSheetSet.can_order_by_unit)가 같은 기준을 쓴다.
// 이 세트는 5,000 유로 제출 하한(최소주문금액)을 두지 않는다.
export function canOrderByUnit(
  lineSheetSet?: CanOrderByUnitSource | null,
  now: number = Date.now()
): boolean {
  if (!lineSheetSet) {
    return false;
  }
  return (
    lineSheetSet.type === "STOCK" &&
    !!lineSheetSet.sendToPathpick &&
    (!lineSheetSet.pathpickDeadline ||
      new Date(lineSheetSet.pathpickDeadline).getTime() > now)
  );
}
